import React, { lazy, Suspense } from 'react';

// Containers
import ErrorBoundary from 'containers/ErrorBoundary';

// Types
import { WebsiteDetailsProps } from './types';

const WebsiteDetailsMF = lazy(() => import('OnboardingModule/WebsiteDetails'));

const WebsiteDetailsLazyComponent = props => (
  <Suspense fallback={<></>}>
    <WebsiteDetailsMF {...props} />
  </Suspense>
);

/**
 * This explicit component with ErrorBoundary is needed because when we place
 * ErrorBoundary directly in LazyComponent, error does not get
 * captured by it, and bubbles up to its parent, causing the app crash.
 */

const WebsiteDetails = (props: WebsiteDetailsProps) => (
  <ErrorBoundary fallback={<></>}>
    <WebsiteDetailsLazyComponent {...props} />
  </ErrorBoundary>
);

export default WebsiteDetails;
